import type { HeroSliderStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import Slider from "./Slider";
import styles from "./hero-slider.module.css";

const HeroSlider = ({
  blok,
  preview,
}: {
  blok: HeroSliderStoryblok;
  preview: boolean;
}): React.JSX.Element => {
  return (
    <div className={styles.root} data-layout="blok">
      <div className={styles.aspectRatio__outer}>
        <div className={styles.aspectRatio__inner}>
          <Slider media={blok.slides}>
            {blok.slides.map((slide) => {
              return (
                <div className={styles.embla__slide} key={slide._uid}>
                  <StoryblokComponent
                    blok={slide}
                    key={slide._uid}
                    preview={preview}
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
